import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { mapCountries } from '../../shared/utils';

const Career = ({ career }) => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    const locations = career?.custom_fields?.[0]?.value;

    return (
        <>
            <a href={`careers?id=${career?.id}`}>
                <div className="row alignment">
                    <div className="col-md-6">
                        <h4 className="career-title">{career?.title}</h4>
                        {locations && (
                            <div className="career-location">
                                <div>{mapCountries(locations)}</div>
                            </div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <div className="padded-block md-padding">
                            <h5 className="text-right">
                                <strong className="text-right">{t('careers.more_details')}</strong>
                            </h5>
                        </div>
                    </div>
                </div>
            </a>
            <hr />
        </>
    );
};

Career.propTypes = {
    career: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Career;
